import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import TranslationUtil from '../../utils/TranslationUtil';
import { getExpediaLinks, companyName } from './eglinks';

const linkSeparator = (key) => (<span key={key}>&nbsp;&nbsp;|&nbsp;&nbsp;</span>);

export function BottomLinks() {
    const getPropsFromState = (state) => {
        const { app } = state;
        const { locale } = app;
        const translations = new TranslationUtil(app.translations, app.fallbackTranslations);
        const getTranslation = (suffix) => translations.getTranslation(`footer.${suffix}`);

        /* istanbul ignore next */
        const brandLinks = (getExpediaLinks(locale.canonical) || []).map((linkElement) => ({
            linkText: getTranslation(`links.${linkElement.key}`),
            link: linkElement.value
        }));

        return {
            links: brandLinks,
            companyName,
            rights: getTranslation('rights'),
            tradeMark: getTranslation('tradeMark'),
            confidential: getTranslation('confidential')
        };
    };

    const {
        links,
        tradeMark,
        rights,
        confidential
    } = useSelector(getPropsFromState, shallowEqual);

    let id = 1;
    const reducer = (prev, curr) => (
        // eslint-disable-next-line no-plusplus
        (prev.length === 0) ? [curr] : [prev, linkSeparator(id++), curr]
    );

    return (
        <div className="eg-footer__linkgroup">

            <p className="eg-footer__copyright">{`© ${new Date().getFullYear()} ${companyName} ${rights} ${tradeMark} ${confidential}`}</p>
            <p className="eg-footer__copyright">
                {
                    links.map((element) => (
                        <a href={element.link} key={element.linkText}>{element.linkText}</a>
                    )).reduce(reducer, [])
                }
            </p>

        </div>
    );
}

BottomLinks.displayName = 'BottomLinks';
export default BottomLinks;
